<template>
  <div>
    <modals-container name="modal1" />
    <v-dialog />
    <div class="class_add_top">
      <a class="back" onclick="history.go(-1)">
        返回
      </a>
      <span v-if="isEdit">编辑</span><span v-if="!isEdit">新增</span>报名
    </div>
    <div class="class_add_con">
      <form data-vv-scope="form" novalidate>
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tr class="tita">
            <td class="left_td">基本信息</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td class="left_td pt30">报名主题：</td>
            <td class="pt20"><input type="text" name="name" v-validate="'required'" v-model="form.name"
                placeholder="60字以内" class="put_495" /></td>
          </tr>
          <div class="error_msg">{{ errors.first('form.name') }}</div>
          <tr>
            <td class="left_td">报名类型：</td>
            <td>
              <select name="enrollType" class="all_select" v-model="form.type">
                <option value="">选择报名类型</option>
                <option v-for="item in selects.enrollType" v-bind:key="item.value" :value="item.value"
                  v-if="item.value">{{ item.label }}</option>
              </select>
              <div class="all_btn" style="display: inline-block;" v-if="form.type == '01' || form.type == '04'"
                @click="show1">+ 选择课程</div>
              <div class="all_btn" style="display: inline-block;" v-if="form.type == '02'" @click="show2">+ 选择直播</div>
              <div class="all_btn" style="display: inline-block;" v-if="form.type == '03'" @click="show3">+ 培训计划</div>
              <div v-if="form.type == '01' || form.type == '04'">
                <table width="786" border="0" cellspacing="1" cellpadding="0" class="px_content">
                  <thead>
                    <tr>
                      <td width="50">序号</td>
                      <td width="130">课程名称</td>
                      <td>操作</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="" v-for="(item, idx) in tmpList1" :key="item.planId"
                      :class="[(idx + 1) % 2 == 0 ? 'tdhang' : '']">
                      <td>{{ idx + 1 }}</td>
                      <td>{{ item.name }}</td>
                      <td style="width: 35px;"><a @click="del(tmpList1, item)" style="cursor: pointer;"><img
                            src="@/assets/images/px_del@2x.png" /></a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="form.type == '02'">
                <table width="786" border="0" cellspacing="1" cellpadding="0" class="px_content">
                  <thead>
                    <tr>
                      <td width="50">序号</td>
                      <td width="130">直播名称</td>
                      <td>操作</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="" v-for="(item, idx) in tmpList2" :key="item.planId"
                      :class="[(idx + 1) % 2 == 0 ? 'tdhang' : '']">
                      <td>{{ idx + 1 }}</td>
                      <td>{{ item.name }}</td>
                      <td style="width: 35px;"><a @click="del(tmpList2, item)" style="cursor: pointer;"><img
                            src="@/assets/images/px_del@2x.png" /></a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="form.type == '03'">
                <table width="786" border="0" cellspacing="1" cellpadding="0" class="px_content">
                  <thead>
                    <tr>
                      <td width="50">序号</td>
                      <td width="130">计划名称</td>
                      <td>操作</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="" v-for="(item, idx) in tmpList3" :key="item.id"
                      :class="[(idx + 1) % 2 == 0 ? 'tdhang' : '']">
                      <td>{{ idx + 1 }}</td>
                      <td>{{ item.title }}</td>
                      <td style="width: 35px;"><a @click="del(tmpList3, item)" style="cursor: pointer;"><img
                            src="@/assets/images/px_del@2x.png" /></a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
          <div class="error_msg">{{ errors.first('form.type') }}</div>
          <tr>
            <td class="left_td">报名时间：</td>
            <td>
              <input type="text" id="J-xl" name="startTime" placeholder="选择开始时间"
                v-model="startTime">&nbsp;&nbsp;至&nbsp;&nbsp;
              <input type="text" id="J-xl-2" name="endTime" placeholder="选择结束时间" v-model="endTime">
            </td>
          </tr>
          <div class="error_msg" v-if="dateValidate">报名时间不能为空, 请设置开始时间/结束时间</div>
          <tr>
            <td class="left_td">报名封面：</td>
            <td class="rdiv pt30">
              <img v-if="form.cover && form.cover !== ''" :src="form.cover" class="upload_img" />
              <UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'cover'" v-if="uploadOSSConf.STS != null"
                @success="OSSUploadSuccess"></UploadOSS>
              <p class="mt10"><span class="tips_text">建议图片长280px宽150px，支持jpg、jpeg、png，图片大小不超过2MB</span></p>
            </td>
          </tr>
          <tr>
            <td class="left_td">报名人数上限：</td>
            <td><input type="text" name="number" v-validate="'required'" v-model="form.number" placeholder="报名人数上限"
                class="put_495" style="width: 180px;" /></td>
          </tr>
          <div class="error_msg">{{ errors.first('form.number') }}</div>
          <tr>
            <td class="left_td" valign="top">报名简介：</td>
            <td valign="top" class="pt20">
              <Ueditor :value="ueditor.value" :config="ueditor.config" ref="ue"></Ueditor>
              <br><br>
            </td>
          </tr>
          <tr class="tita" v-if="form.type == '04'">
            <td class="left_td">线下课程信息</td>
            <td>&nbsp;</td>
          </tr>
          <tr v-if="form.type == '04'">
            <td class="left_td pt30">授课地点：</td>
            <td class="pt20">
              <input type="text" name="location" v-validate="'required'" v-model="form.site" placeholder="填写地点"
                class="put_495" />
            </td>
          </tr>
          <div class="error_msg">{{ errors.first('form.location') }}</div>
          <tr v-show="form.type == '04'">
            <td class="left_td">授课时间：</td>
            <td>
              <input type="text" id="J-xl-3" name="lectureStartTime" placeholder="选择开始时间" v-model="lectureStartTime"
                style="width: auto;"> 至
              <input type="text" id="J-xl-4" name="lectureEndTime" placeholder="选择结束时间" v-model="lectureEndTime"
                style="margin-left: 0; width: auto;">
            </td>
          </tr>
          <div class="error_msg" v-if="form.type == '04' && dateValidate1">授课时间不能为空, 请设置开始时间/结束时间</div>
          <tr v-show="form.type == '04'">
            <td class="left_td" valign="top">授课讲师：</td>
            <td>
              <dl class="js_man" v-for="item in teacherList" :key="item.id">
                <a class="all_del_icon" @click="delTSelectedId(currentTCIds, item.id)"></a>
                <dt>
                  <img src="@/assets/images/teacher-avatar.png" width="166" height="166"
                    v-if="!item.faceUrl || item.faceUrl == ''" />
                  <img :src="item.faceUrl" v-if="item.faceUrl && item.faceUrl !== ''" width="166" height="166">
                </dt>
                <dd>{{ item.name }}</dd>
              </dl>
              <div class="clear"></div>
              <p><a href="javascript:void(0);" @click="addTeacher(currentTCIds)" class="add_bt_all mt5">添加讲师</a><br />
              </p>
            </td>
          </tr>
          <tr class="tita">
            <td class="left_td">报名设置</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td class="left_td pt20" style="padding-top: 20px;" valign="top">推送范围(显示到前台"任务"列表中)：</td>
            <td class="pt20" valign="top">
              <input name="see" type="radio" value="2" v-model="form.visiblerange" />
              全员
              <input name="see" type="radio" value="1" v-model="form.visiblerange" />
              指定人员　
              <input name="see" type="radio" value="0" v-model="form.visiblerange" />
              无
              <!--指定人员-->
              <dl class="qa_man_add" v-if="form.visiblerange == '1'">
                <dt><a href="javascript:void(0);" @click="showRange" class="on">+选择</a></dt>
                <dd v-if="publicStateList.length > 0">
                  已选标签{{ rangePermission.getPersonTypes(publicStateList).tags }}个,
                  已选用户{{ rangePermission.getPersonTypes(publicStateList).users }}个,
                  已选人员{{ rangePermission.getPersonTypes(publicStateList).members }}个,
                  已选部门{{ rangePermission.getPersonTypes(publicStateList).depts }}个
                  <!--span v-for="item in publicStateList" :key="item.id" style="background: none; height: 36px; line-height: 36px; text-align: center; width: auto; margin-bottom: 0; margin-left: 0;">{{item.name}}</span-->
                </dd>
              </dl>
              <!--/指定人员-->
            </td>
          </tr>
          <tr>
            <td class="left_td " valign="top" style="padding-top:20px;">可见范围(显示到前台"报名"列表中)：</td>
            <td class="pt20" valign="top">
              <p>
                <input name="see2" type="radio" value="2" v-model="form.scope" />
                全员
                <input name="see2" type="radio" value="1" v-model="form.scope" />
                指定人员
                <input name="see2" type="radio" value="0" v-model="form.scope" />
                无
              </p>
              <!--指定人员-->
              <dl class="qa_man_add" v-if="form.scope == '1'">
                <dt><a href="javascript:void(0);" @click="showScope" class="on">+选择</a></dt>
                <dd v-if="scopeList.length > 0">
                  已选标签{{ rangePermission.getPersonTypes(scopeList).tags }}个,
                  已选用户{{ rangePermission.getPersonTypes(scopeList).users }}个,
                  已选人员{{ rangePermission.getPersonTypes(scopeList).members }}个,
                  已选部门{{ rangePermission.getPersonTypes(scopeList).depts }}个
                  <!--span v-for="item in scopeList" :key="item.id" style="background: none; height: 36px; line-height: 36px; text-align: center; width: auto; margin-bottom: 0; margin-left: 0;">{{item.name}}</span-->
                </dd>
              </dl>
              <!--/指定人员-->
            </td>
          </tr>
          <tr class="tita">
            <td class="left_td">其他设置</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td class="left_td">状态：</td>
            <td>
              <input name="state" type="radio" value="1" v-model="form.state" /> 上架
              <input name="state" type="radio" value="0" v-model="form.state" /> 下架
            </td>
          </tr>
          <tr>
            <td class="left_td">是否推送平台：</td>
            <td>
              <input name="platform" type="radio" value="1" v-model="form.platform" /> 是
              <input name="platform" type="radio" value="0" v-model="form.platform" /> 否
            </td>
          </tr>
          <tr>
            <td class="left_td">是否收费：</td>
            <td>
              <input name="time" type="radio" value="0" v-model="isFree" />
              免费　　
              <input name="time" type="radio" value="1" v-model="isFree" />
              收费
              <label class="timeLabel" v-if="isFree == '1'">
                <input name="" class="put_num" type="text" value="5888" v-model="form.cost" />
                元
              </label>
            </td>
          </tr>
          <div class="error_msg" v-if="costValidate" style="left: 100%; width: 100%;">收费情况下价格不能为0,请填写正确金额</div>
          <tr>
            <td class="left_td">支付方式：</td>
            <td>
              <input name="payType" type="radio" value="1" v-model="form.paytype" /> 在线支付
              <!--input name="payType" type="radio" value="2" v-model="form.payType" /> 线下支付 -->
            </td>
          </tr>
          <tr>
            <td class="left_td">报名人员自动确认：</td>
            <td>
              <input name="autoConfirm" type="radio" value="1" v-model="form.autoconfirm" /> 是
              <input name="autoConfirm" type="radio" value="0" v-model="form.autoconfirm" /> 否
            </td>
          </tr>
        </table>
        <p class="btn_center">
          <input name="" type="button" class="all_btn" value="提交完成" @click="validateForm('form')" />
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import api from '@/api'
import { mapState, mapActions, mapGetters } from 'vuex'
import '@/utils/validator.js'
import utils from '@/utils'
import Bus from '@/utils/bus'
import UploadOSS from '@/components/common/upload/uploadOSS.vue'
import Ueditor from '@/components/common/UE/ue'
import teacherSelect from '@/page/byl/org/teacher/select.vue'
import CourseSelect from '@/page/byl/org/course/select.vue'
import liveplaySelect from '@/page/byl/org/livePlay/select.vue'
import planSelect from '@/page/byl/org/plan/select.vue'
import ModalBox from '@/components/common/modal/index.vue'
import rangeManip from '@/components/byl/rangeManip/index.vue'
import rangePermission from '@/utils/rangePermission'
export default {
  components: { UploadOSS, Ueditor },
  data() {
    return {
      rangePermission: rangePermission,
      form: {
        visiblerange: '0',
        scope: '2',
        state: '1', // 上架or下架
        platform: '1', //
        paytype: '1',
        type: '',
        number: 0, // 报名人数上限（0表示没有限制）
        autoconfirm: '1', // 报名是否自动确认
        businessId: '0',
        cover: ''
      },
      startTime: '',
      endTime: '',
      lectureStartTime: '',
      lectureEndTime: '',
      dateValidate: false,
      dateValidate1: false,
      costValidate: false,
      tmpList1: [], // 课程的列表，线上课和线下课
      tmpList2: [],
      tmpList3: [],
      teacherList: [],
      currentTCIds: [],
      selects: {
        enrollType: []
      },
      isFree: 0,
      ueditor: {
        value: '',
        config: {
          initialFrameWidth: 790,
          initialFrameHeight: 227
        }
      },
      publicStateList: [], // 推送范围人员列表
      scopeList: [], // 可见范围列表
      prefix: this.$route.meta.prefix || '',
      uploadOSSConf: { showMode: '1', style: 'img_upload', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null }
    }
  },
  mounted() {
    this.getSTS()
    this.OSSUploadSuccess()
    this.initLayDate()
    this.selects.enrollType = this.enrollType // 先循环出selects下拉框
    if (this.isEdit) { // 通过 id 取信息并且要给select赋值
      this.getModel(this.$route.params.id)
      this.$on('data-prepared', function (data) {
        if (data.cost && data.cost > 0) { this.isFree = '1' }
        this.startTime = utils.dateFormat(new Date(data.starttime), 'yyyy-MM-dd hh:mm:ss') // 日期格式化
        this.endTime = utils.dateFormat(new Date(data.endtime), 'yyyy-MM-dd hh:mm:ss') // 日期格式化
        this.lectureStartTime = utils.dateFormat(new Date(data.lectureStartTime), 'yyyy-MM-dd hh:mm:ss') // 日期格式化
        this.lectureEndTime = utils.dateFormat(new Date(data.lectureEndTime), 'yyyy-MM-dd hh:mm:ss') // 日期格式化
        this.ueditor.value = this.$refs.ue.setUEContent(data.content)
        if (this.form.teachers) {
          this.getTeacherListByIds(this.form.teachers.split(','))
        }
        rangePermission.getRange(this.$route.params.id, '04', this.form.visiblerange).then((r) => {  // 获取推送范围
          this.publicStateList = r
        })
        rangePermission.getScope(this.$route.params.id, '04', this.form.scope).then((r) => {  // 获取推送范围
          this.scopeList = r
        })
        switch (data.type) {
          case '01': {
            this.getCourseListByIds([data.businessId])
            break
          }
          case '02': {
            this.getLivePlayListByIds([data.businessId])
            break
          }
          case '03': {
            this.getPlanListByIds([data.businessId])
            break
          }
          case '04': {
            this.getCourseListByIds([data.businessId])
            break
          }
        }
      });
    }
    Bus.$on('set-selected-plan', (data) => {
      if (data.length > 1) {
        this.$toasted.show('一个报名只能添加一个计划')
      } else {
        this.getPlanListByIds(data)
      }
    })
    Bus.$on('selectedCourses', (data) => {
      if (data.length > 1) {
        this.$toasted.show('一个报名只能添加一个课程')
      } else {
        if (data) {
          this.getCourseListByIds(data)
        }
      }
    })
    Bus.$on('selectedLivePlays', (data) => {
      if (data.length > 1) {
        this.$toasted.show('一个报名只能添加一个直播')
      } else {
        this.getLivePlayListByIds(data)
      }
    })
    Bus.$on('selectedTeachers', (data) => {
      this.currentTCIds = data
      this.getTeacherListByIds(this.currentTCIds)
    })
  },
  watch: {
    'startTime': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.dateValidate = false
        } else {
          this.dateValidate = true
        }
      },
      deep: true
    },
    'endTime': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.dateValidate = false
        } else {
          this.dateValidate = true
        }
      },
      deep: true
    },
    'lectureStartTime': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.dateValidate1 = false
        } else {
          this.dateValidate1 = true
        }
      },
      deep: true
    },
    'lectureEndTime': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.dateValidate1 = false
        } else {
          this.dateValidate1 = true
        }
      },
      deep: true
    },
    isFree(val) {
      if (val == '0') {
        this.costValidate = false
      }
      if (val == '1') {
        this.costValidate = true
      }
    },
    'form.cost'(val) {
      if (!val) { val = 0 }
      if (val > 0) {
        this.costValidate = false
      } else {
        if (this.isFree == '0') {
          this.costValidate = false
        } else {
          this.costValidate = true
        }
      }
    }
  },
  computed: {
    ...mapState('dropdowns', ['enrollType']),
    ...mapState('auth', ['user', 'token']),
    ...mapState('plan', ['lists', 'selectedPlan']),
    ...mapGetters('auth', ['getCurrentOrg', 'getToken']),
    isEdit() {
      return this.$route.params.id && this.$route.params.id !== 'void'
    }
  },
  methods: {
    show1() {
      let excludeIds = this.createIds(this.tmpList1, '00')
      var online;
      if (this.form.type == '01') {
        online = '1'
      } else if (this.form.type == '04') {
        online = '0'
      }
      this.$modal.show(CourseSelect, {
        ids: excludeIds,
        online: online // 区分线上课或是线下课
      })
    },
    show2() {
      let excludeIds = this.createIds(this.tmpList2, '01')
      this.$modal.show(liveplaySelect, {
        ids: excludeIds
      })
    },
    show3() {
      let excludeIds = this.createIds(this.tmpList3, '02')
      this.$modal.show(planSelect, {
        ids: excludeIds
      })
    },
    del(arr, item) {
      utils.removeObjWithArr(arr, item)
    },
    popup(msg) {
      this.$toasted.show(msg)
    },
    confirmBox(o) {
      var that = this
      this.$modal.show('dialog', {
        title: '提交',
        text: '确认提交吗？',
        buttons: [
          {
            title: '确认',
            default: true,
            handler: utils.debounce(() => {
              if (o.yes && o.yes instanceof Function) {
                o.yes()
                that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
              }
            }, 1000)
          },
          {
            title: '取消'
          }
        ]
      })
    },
    validateForm(scope) {
      var bus = this
      var _dealParams = function () { // 处理发送给后台的数据结构
        bus.form.starttime = bus.startTime
        bus.form.endtime = bus.endTime
        bus.form.lectureStartTime = bus.lectureStartTime
        bus.form.lectureEndTime = bus.lectureEndTime
        bus.form.teachers = utils.arr2str(utils.grabVal(bus.teacherList, 'id'))
        if (bus.isFree == '0') { bus.form.cost = 0 }
        switch (bus.form.type) {
          case '01': {
            if (bus.tmpList1.length > 0) {
              bus.form.businessId = bus.tmpList1[0].id
            } else { // 将报名类型和资源Id置空
              bus.form.businessId = ''
              bus.form.type = ''
            }
            break
          }
          case '04': {
            if (bus.tmpList1.length > 0) {
              bus.form.businessId = bus.tmpList1[0].id
            } else { // 将报名类型和资源Id置空
              bus.form.businessId = ''
              bus.form.type = ''
            }
            break
          }
          case '02': {
            if (bus.tmpList2.length > 0) {
              bus.form.businessId = bus.tmpList2[0].id
            } else { // 将报名类型和资源Id置空
              bus.form.businessId = ''
              bus.form.type = ''
            }
            break
          }
          case '03': {
            if (bus.tmpList3.length > 0) {
              bus.form.businessId = bus.tmpList3[0].id
            } else { // 将报名类型和资源Id置空
              bus.form.businessId = ''
              bus.form.type = ''
            }
            break
          }
        }
        bus.form.content = bus.$refs.ue.getUEContent()
      }
      var _validate = function () {
        var r1 = false
        var r2 = false
        var r3 = false
        if (!bus.startTime || !bus.endTime) {
          bus.dateValidate = true
          bus.popup('报名时间不能为空')
        } else {
          r1 = true
        }
        if (bus.form.type == '04' && (!bus.lectureStartTime || !bus.lectureEndTime)) {
          bus.dateValidate1 = true
          bus.popup('线下课程授课时间不能为空')
        } else {
          r3 = true
        }
        if (bus.isFree == '1' && bus.form.cost <= 0) {
          bus.costValidate = true
          bus.popup('价格填写有误')
        } else {
          r2 = true
        }
        return r1 && r2 && r3
      }
      this.$validator.validateAll(scope).then(function (result) {
        if (result) {
          if (_validate()) {
            if (bus.isEdit) { // 编辑
              _dealParams()
              bus.confirmBox({
                yes: function () {
                  api.post(config.enrollApiPath, '/signupinfo/save', bus.form, function (r) { // 正常
                    bus.popup('保存成功')
                    rangePermission.saveTo(bus.form.id, '04', { type: bus.form.visiblerange, value: bus.publicStateList }, { type: bus.form.scope, value: bus.scopeList })
                    bus.$router.push(bus.prefix + '/org/enrollList')
                  })
                }
              })
            } else { // 新增
              _dealParams()
              bus.confirmBox({
                yes: function () {
                  api.post(config.enrollApiPath, '/signupinfo/save', bus.form, function (r) { // 正常
                    bus.popup('创建报名成功')
                    rangePermission.saveTo(r.data.id, '04', { type: bus.form.visiblerange, value: bus.publicStateList }, { type: bus.form.scope, value: bus.scopeList })
                    bus.$router.push(bus.prefix + '/org/enrollList')
                  })
                }
              })
            }
          }
        } else {
          bus.popup('请确保信息正确与完整')
          return false
        }
      })
    },
    to(path) {
      this.$router.push(path)
    },
    getModel(id) {
      var that = this
      api.get(config.enrollApiPath, '/signupinfo/get', { id: id }, function (r) { // 正常
        that.form = r.data
        that.$emit('data-prepared', that.form)
      })
    },
    getTeacherListByIds(idsArr) {
      let idStr = ''
      if (idsArr && idsArr.length > 0) {
        for (let i = 0; i < idsArr.length; i++) {
          if (i < idsArr.length - 1) {
            idStr += idsArr[i] + ','
          } else if (i == idsArr.length - 1) {
            idStr += idsArr[i]
          }
        }
      }
      this.$api.get(this.$global.teacherApiPath, '/teacher/batch', { ids: idStr }, r => {
        this.teacherList = r.data
      })
    },
    addTeacher(ids) {
      this.$modal.show(teacherSelect, {
        ids: ids
      })
    },
    delTSelectedId(ids, id) {
      for (let i = 0; i < ids.length; i++) {
        if (ids[i] === id) {
          ids.splice(i, 1);
        }
      }
      for (let i = 0; i < this.teacherList.length; i++) {
        if (this.teacherList[i].id === id) {
          this.teacherList.splice(i, 1)
        }
      }
    },
    initLayDate() {
      var self = this
      var startTime = laydate.render({
        elem: '#J-xl',
        type: 'datetime',
        done: function (value, date) {
          endTime.config.min = {
            year: date.year,
            month: date.month - 1, //关键
            date: date.date,
            hours: 0,
            minutes: 0,
            seconds: 0
          };
          self.startTime = value;
        }
      });
      var endTime = laydate.render({
        elem: '#J-xl-2',
        type: 'datetime',
        done: function (value, date) {
          startTime.config.max = {
            year: date.year,
            month: date.month - 1, //关键
            date: date.date,
            hours: 0,
            minutes: 0,
            seconds: 0
          }
          self.endTime = value;
        }
      });
      var lectureStartTime = laydate.render({
        elem: '#J-xl-3',
        type: 'datetime',
        done: function (value, date) {
          lectureEndTime.config.min = {
            year: date.year,
            month: date.month - 1, //关键
            date: date.date,
            hours: 0,
            minutes: 0,
            seconds: 0
          };
          self.lectureStartTime = value;
        }
      });
      var lectureEndTime = laydate.render({
        elem: '#J-xl-4',
        type: 'datetime',
        done: function (value, date) {
          lectureStartTime.config.max = {
            year: date.year,
            month: date.month - 1, //关键
            date: date.date,
            hours: 0,
            minutes: 0,
            seconds: 0
          }
          self.lectureEndTime = value;
        }
      });
    },
    OSSUploadSuccess(r) {
      if (r && r != '') {
        this.$set(this.form, r.dom_id, r.res.requestUrls[0])
      }
    },
    getSTS() {
      this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
        let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
        this.uploadOSSConf.STS = STS
      })
    },
    createIds(arr, type) {
      var r = []
      for (var i = 0; i < arr.length; i++) {
        let s = arr[i]
        switch (type) {
          case '00': {
            r.push(s.id)
            break
          }
          case '01': {
            r.push(s.id)
            break
          }
          case '02': {
            r.push(s.id)
            break
          }
        }
      }
      return r
    },
    getCourseListByIds(idsArr) {
      this.$api.get(this.$global.courseApiPath, '/course/batch', { ids: utils.arr2str(idsArr) }, r => {
        this.tmpList1 = r.data
      })
    },
    getLivePlayListByIds(idsArr) {
      let s = utils.arr2str(idsArr)
      this.$api.post(this.$global.livePlayApiPath, '/livePlayInfo/batchGet', { ids: s }, r => {
        this.tmpList2 = r.data
      })
    },
    getPlanListByIds(idsArr) {
      this.$api.post(this.$global.planApiPath, '/trainingplans/search', { includedIds: idsArr }, r => {
        this.tmpList3 = r.data
      })
    },
    showRange() {
      var that = this
      this.$modal.show(ModalBox, {
        opts: {
          title: '设置推送范围',
          styles: {
            width: '960',
            height: String(0.8242 * window.screen.availHeight)
          },
          currentComponent: {
            name: 'range',
            template: rangeManip,
            outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
            inputs: that.publicStateList // 向组件内传入的数据, 一般用于初始化
          },
          yes(val) { // 点击确认后要做的事情
            that.publicStateList = val
          },
          closed() { // 这里要判断, 只有新增状态下需要清空
            if (that.$route.params.id == 'create') {
              that.publicStateList = []
            }
          }
        }
      })
    },
    showScope() {
      var that = this
      this.$modal.show(ModalBox, {
        opts: {
          title: '设置可见范围',
          styles: {
            width: '960',
            height: String(0.8242 * window.screen.availHeight)
          },
          currentComponent: {
            name: 'range',
            template: rangeManip,
            outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
            inputs: that.scopeList // 向组件内传入的数据, 一般用于初始化
          },
          yes(val) { // 点击确认后要做的事情
            that.scopeList = val
          },
          closed() { // 这里要判断, 只有新增状态下需要清空
            if (that.$route.params.id == 'create') {
              that.scopeList = []
            }
          }
        }
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/page/byl/org/enroll/model.vue